import { FC, useContext } from 'react'
import { Form, InputNumber } from 'antd'
import { EditableCellCtx } from '../editable-cell'

interface NumberOfFormsProps {}

const NumberOfForms: FC<NumberOfFormsProps> = () => {
    const ctx = useContext(EditableCellCtx)

    return (
        <Form.Item name={'numberOfForms'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} />
        </Form.Item>
    )
}

export default NumberOfForms
